module.exports = __webpack_public_path__ + "img/15.50f8bd6d.png";